/**
 * TP13 Configuration - Source unique de vérité
 * Toutes les constantes du projet TP13
 */

// ============================================================================
// BRAND & SITE
// ============================================================================
export const BRAND_NAME = "TP13";
export const SITE_URL = "https://tp13.fr";
export const DOMAIN = "https://tp13.fr";

// ============================================================================
// SEO & SOCIAL
// ============================================================================
export const OG_IMAGE_DEFAULT = `https://static.readdy.ai/image/e6848456e15486ce908a657fc60b2048/acd6284e2665374d14e5f03638190f26.png`;
export const OG_IMAGE_ALT_DEFAULT = "TP13 — Marques Virtuelles & Apporteurs d'Affaires Restauration";
export const TWITTER_SITE = "@TP13fr";

// ============================================================================
// EMAILS
// ============================================================================
export const EMAIL_CONTACT = "contact@tp13.fr";
export const EMAIL_SUPPORT = "support@tp13.fr";
export const EMAIL_ADMIN = "admin@tp13.fr";
export const EMAIL_CANDIDATURE = "candidature@tp13.fr";
export const PHONE_PRO = "02 61 53 72 28";

// ============================================================================
// FORMULAIRES / CTA
// ============================================================================
export const FORM_URL_AO = "https://162b-contact.systeme.io/2ef2cc09";
export const FORM_URL_COMMERCE = "https://162b-contact.systeme.io/decd49a1";
export const CALENDLY_URL = "https://calendly.com/karlcibois/30min";

// ============================================================================
// COMMISSIONS TP13 RÉELLES
// ============================================================================
export const COMMISSION_MAIN_MIN = 15;
export const COMMISSION_MAIN_MAX = 20;
export const COMMISSION_VIRTUAL_MIN = 10;
export const COMMISSION_VIRTUAL_MAX = 15;

// ============================================================================
// MERCURIALE
// ============================================================================
export const MERCURIALE_MIN = 15;
export const MERCURIALE_MAX = 30;
export const MERCURIALE_DISCLAIMER = "selon les produits";

// ============================================================================
// DOCUMENTS REQUIS
// ============================================================================
export const DOCS_AO: string[] = [
  "KBIS",
  "Pièce d'identité recto/verso",
  "RIB"
];

export const DOCS_COMMERCE: string[] = [
  "CNI",
  "KBIS",
  "RIB",
  "Menu actuel",
  "HACCP"
];

// ============================================================================
// WEBHOOK / INTEGRATIONS
// ============================================================================
export const MAKE_WEBHOOK_URL = import.meta.env.VITE_MAKE_WEBHOOK_URL || "";
export const MAKE_WEBHOOK_ENABLED = MAKE_WEBHOOK_URL.trim().length > 0;

// ============================================================================
// LEGAL / COMPANY
// ============================================================================
export const LEGAL_COMPANY_NAME = "TP13 FRANCE";
export const LEGAL_COMPANY_FORM = "SASU";
export const LEGAL_FORM = "SASU (Société par Actions Simplifiée Unipersonnelle)";
export const LEGAL_CAPITAL = "100,00 €";
export const LEGAL_CAPITAL_EUR = "100,00 €";
export const LEGAL_ADDRESS = "La Guéronnière, 61140 Bagnoles-de-l'Orne Normandie, France";
export const LEGAL_SEAT = "La Guéronnière, 61140 Bagnoles-de-l'Orne Normandie, France";
export const LEGAL_PRESIDENT = "Karl Cibois";
export const LEGAL_PRESIDENT_NAME = "Karl Cibois";
export const LEGAL_SIRET = "994 052 496 00019";
export const LEGAL_SIREN = "994 052 496";
export const LEGAL_RCS = "Alençon";
export const LEGAL_RCS_FULL = "994 052 496 R.C.S. Alençon";
export const LEGAL_RCS_NUMBER = "994 052 496 R.C.S. Alençon";
export const LEGAL_MANAGEMENT_NUMBER = "2025B00670";
export const LEGAL_GESTION_NUMBER = "2025B00670";
export const LEGAL_IMMATRICULATION_DATE = "04 décembre 2025";
export const LEGAL_ACTIVITY_START_DATE = "12 novembre 2025";
export const LEGAL_APE = "6312Z - Portails internet";
export const LEGAL_TVA = "TVA non applicable, article 293 B du CGI";
export const LEGAL_EUID = "FR.994052496.2025B00670";

// ============================================================================
// HOSTING
// ============================================================================
export const HOSTING_PROVIDER = "Vercel Inc.";
export const HOSTING_ADDRESS = "440 N Barranca Ave #4133, Covina, CA 91723, États-Unis";

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================
export function isQAMode(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get("qa") === "1";
}
